module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_vm._v("“Let there be light!” said God,")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("and there was light!")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("“Let there be blood!” says man,")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("and there’s a sea!")]), _vm._v(" "), _c('p', {
    staticClass: "fm3"
  }, [_vm._v("—Lord Byron, "), _c('i', [_vm._v("Don Juan")])]), _vm._v(" "), _c('p', {
    staticClass: "fm4"
  }, [_vm._v("“Let them drown in their own stinking sea of blood!”")]), _vm._v(" "), _c('p', {
    staticClass: "fm5"
  }, [_c('span', [_vm._v("—Mack Bolan,")])]), _vm._v(" "), _c('p', {
    staticClass: "fm5"
  }, [_c('span', [_vm._v("THE EXECUTIONER")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a0ce86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/franmatter01.vue
// module id = 75
// module chunks = 0